import XHTTP from "services/api/xhttp";
import paths from "routes/paths";

class VisitorCharacteristicsApi {
  static END_POINTS = {
    getVisitorStats: () =>
      paths.api.visitor_characteristics.dataByAreas.visitorStats,
    getVisitors: () => paths.api.visitor_characteristics.dataByAreas.visitors,
    getCategorizeVisitors: () =>
      paths.api.visitor_characteristics.dataByAreas.categorizeVisitors,
    getTimeSpent: () => paths.api.visitor_characteristics.dataByAreas.timeSpent,
    getDestinations: () =>
      paths.api.visitor_characteristics.dataByAreas.destinations,
    getCatchmentAreas: () =>
      paths.api.visitor_characteristics.dataByRadius.catchmentAreas,
  };

  static getVisitorStats(data) {
    return XHTTP(`${VisitorCharacteristicsApi.END_POINTS.getVisitorStats()}`, {
      method: "post",
      body: JSON.stringify(data),
      abortMultiple: false,
    });
  }

  static getVisitors(data, filters) {
    return XHTTP(`${VisitorCharacteristicsApi.END_POINTS.getVisitors()}`, {
      method: "post",
      body: JSON.stringify(data),
      abortMultiple: false,
    });
  }

  static getCategorizeVisitors(data, filters) {
    return XHTTP(
      `${VisitorCharacteristicsApi.END_POINTS.getCategorizeVisitors()}`,
      {
        method: "post",
        body: JSON.stringify(data),
        abortMultiple: false,
      }
    );
  }

  static getTimeSpent(data) {
    return XHTTP(`${VisitorCharacteristicsApi.END_POINTS.getTimeSpent()}`, {
      method: "post",
      body: JSON.stringify(data),
      abortMultiple: false,
    });
  }

  static getDestinations(data) {
    return XHTTP(`${VisitorCharacteristicsApi.END_POINTS.getDestinations()}`, {
      method: "post",
      body: JSON.stringify(data),
      abortMultiple: false,
    });
  }

  static getCatchmentAreas(data) {
    return XHTTP(
      `${VisitorCharacteristicsApi.END_POINTS.getCatchmentAreas()}`,
      {
        method: "post",
        body: JSON.stringify(data),
        abortMultiple: true,
      }
    );
  }
}

export default VisitorCharacteristicsApi;
